import { HANDIN_PROVIDER, LTI1P3_PROVIDER } from '@core/assignments/constants';

const normalizeAssignmentProvider = (provider?: string | null) => {
  if (!provider) {
    return null;
  }

  if (provider === 'handin') {
    return HANDIN_PROVIDER;
  }

  return provider;
};

export const isHandinProvider = (provider?: string | null) =>
  normalizeAssignmentProvider(provider) === HANDIN_PROVIDER;

export const isLti1p3Provider = (provider?: string | null) =>
  normalizeAssignmentProvider(provider) === LTI1P3_PROVIDER;

export default normalizeAssignmentProvider;
